import {commitMutation, graphql} from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation CopyWidgetsMutation(
    $input: CopyWidgetsInput!
  ) {
    copyWidgets(input: $input) {
      reports {
        id
      }
    }
  }
`;

function commit({destinationReportIds, widgetIds}, callback) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          destinationReportIds,
          widgetIds,
        },
      },
      onCompleted: (res) => {
        callback(null, res);
      },
      onError: (err) => {
        callback(err);
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/CopyWidgetsMutation.js